'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.month;


// WEBPACK FOOTER //
// ./~/sugar-date/number/month.js